const doc = [({"en":({"js":({"admin":({"messages":({"create_modal":({"the_message_was_created":"The message was created"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;